import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4d7f1911"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "task-list__date" }
const _hoisted_2 = { class: "task-list__date-wrapper" }
const _hoisted_3 = { class: "task-list__day" }
const _hoisted_4 = { class: "task-list__month" }
const _hoisted_5 = { class: "task-list__date-wrapper" }
const _hoisted_6 = { class: "task-list__weekday" }
const _hoisted_7 = { class: "task-list__time" }
const _hoisted_8 = { class: "task-list__year" }
const _hoisted_9 = { class: "task-list__text-wrapper" }
const _hoisted_10 = { class: "task-list__title" }
const _hoisted_11 = {
  key: 0,
  class: "task-list__title task-list__title--completed"
}
const _hoisted_12 = { class: "task-list__wrapper" }
const _hoisted_13 = { class: "task-list__importance" }
const _hoisted_14 = {
  key: 0,
  class: "task-list__author"
}
const _hoisted_15 = {
  key: 0,
  class: "task-list__access"
}
const _hoisted_16 = {
  key: 1,
  class: "task-list__btns"
}
const _hoisted_17 = {
  key: 2,
  class: "task-list__btns"
}

import { computed, ref } from 'vue';
import { useRouter } from 'vue-router';
import { Task } from '@/types/task';
import BasicSvgIcon from '@/components/UI/BasicSvgIcon.vue';
import DateObjTypes from '@/types/dateObjTypes';
import { createNamespacedHelpers } from 'vuex-composition-helpers';
import BasicButton from '@/components/UI/BasicButton.vue';
import TaskModal from '@/components/TaskModal.vue';
import ModalDescription from '@/types/modalDescription';


export default /*#__PURE__*/_defineComponent({
  __name: 'TasksListTask',
  props: {
    task: {},
    isError: { type: Boolean },
    completed: { type: Boolean }
  },
  emits: ["deleteTask", "completeTask"],
  setup(__props: any, { emit }) {

const props = __props;

const taskModule = createNamespacedHelpers('taskModule');
const authModule = createNamespacedHelpers('authModule');


const router = useRouter();
const { setTaskIdToEdit } = taskModule.useMutations(['setTaskIdToEdit']);
const { getUser } = authModule.useGetters(['getUser']);

const prettifyDateToObj = (someDate): DateObjTypes => {
  const date = new Date(someDate);

  return {
    year: date.toLocaleString('ru-RU', { year: 'numeric'}),
    month: date.toLocaleString('ru-RU', { month: 'short'}),
    weekday: date.toLocaleString('ru-RU', { weekday: 'short' }),
    day: date.toLocaleString('ru-RU', { day: 'numeric' }),
    time: date.toLocaleString('ru-RU', {hour: '2-digit', minute: '2-digit' }),
  };
};

const prettifyDateToStr = (someDate: Date): string => new Date(someDate).toLocaleString();

const prettifyCreationDate = (computed((): DateObjTypes => prettifyDateToObj(props.task.date)));
const prettifyCompletionDate = (computed((): string => prettifyDateToStr(props.task.completedAt)));
const isOverdue = (computed((): boolean => Date.now() > new Date(props.task.date).getTime()));
const isHasRights = (computed((): boolean => getUser.value.data.uid === props.task.author.uid));
const getName = (computed((): string => props.task.author.displayName));

const modalsProperties: ModalDescription = {
  delete: {
    title: 'Вы уверены что хотите удалить задачу?',
    id: 'deleteModal',
  },
  closeRightsError: {
    title: 'У Вас нет доступа для этой операции',
    id: 'closeRightsErrorModal',
  },
  closeError: {
    title: 'Произошла ошибка, попробуйте еще раз',
    id: 'closeErrorModal',
  },
};



const root = ref<HTMLElement | null>(null);

const toggleModal = (id: string) => {
  const modal = root.value?.querySelector(`#${id}`) as HTMLElement;
  modal.classList.toggle('is-active');
}

const toggleModalAndResetRightsError = () => {
  toggleModal(modalsProperties.closeRightsError.id);
}

const checkingBeforeDeleteTask = () => {
  if (isHasRights.value) {
    toggleModal(modalsProperties.delete.id);
  } else {
    toggleModalAndResetRightsError();
  }
}

const deleteTask = (id) => {
  emit('deleteTask', id);
}

const completeTask = (task) => {
  if (isHasRights.value) {
    emit('completeTask', task);
  } else {
    toggleModalAndResetRightsError();
  }
}

const gotToTaskEditPage = (id: string) => {
  if (isHasRights.value) {
    setTaskIdToEdit(id);
    router.push(`/edit-task/${id}`)
  } else {
    toggleModalAndResetRightsError();
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", {
    ref_key: "root",
    ref: root,
    class: _normalizeClass(["task-list__element", { 'task-list__element--overdue': isOverdue.value, 'task-list__element--completed': _ctx.completed }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", _hoisted_3, _toDisplayString(prettifyCreationDate.value.day), 1),
        _createElementVNode("p", _hoisted_4, _toDisplayString(prettifyCreationDate.value.month), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("p", _hoisted_6, _toDisplayString(prettifyCreationDate.value.weekday), 1),
        _createElementVNode("p", _hoisted_7, _toDisplayString(prettifyCreationDate.value.time), 1)
      ]),
      _createElementVNode("p", _hoisted_8, _toDisplayString(prettifyCreationDate.value.year), 1)
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.task.title), 1),
      (_ctx.completed)
        ? (_openBlock(), _createElementBlock("p", _hoisted_11, " Завершено - " + _toDisplayString(prettifyCompletionDate.value), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("p", _hoisted_13, " Важность: " + _toDisplayString(_ctx.task.importance), 1),
        (_ctx.task.access)
          ? (_openBlock(), _createElementBlock("p", _hoisted_14, " Владелец: " + _toDisplayString(getName.value), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.task.access)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, " Групповое "))
      : _createCommentVNode("", true),
    (_ctx.completed)
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _createVNode(BasicButton, {
            class: "btn--green",
            type: "button",
            title: "Вернуть в работу",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (completeTask(_ctx.task)))
          }, {
            default: _withCtx(() => [
              _createVNode(BasicSvgIcon, {
                name: "redo-icon",
                width: "32",
                height: "32"
              })
            ]),
            _: 1
          })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _createVNode(BasicButton, {
            class: "btn--red",
            type: "button",
            title: "Удалить",
            onClick: checkingBeforeDeleteTask
          }, {
            default: _withCtx(() => [
              _createVNode(BasicSvgIcon, {
                name: "delete-icon",
                width: "32",
                height: "32"
              })
            ]),
            _: 1
          }),
          _createVNode(BasicButton, {
            class: "btn--yellow",
            type: "button",
            title: "Редактировать",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (gotToTaskEditPage(_ctx.task.id)))
          }, {
            default: _withCtx(() => [
              _createVNode(BasicSvgIcon, {
                name: "edit-icon",
                width: "32",
                height: "32"
              })
            ]),
            _: 1
          }),
          _createVNode(BasicButton, {
            class: "btn--green",
            type: "button",
            title: "Завершить",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (completeTask(_ctx.task)))
          }, {
            default: _withCtx(() => [
              _createVNode(BasicSvgIcon, {
                name: "check-icon",
                width: "32",
                height: "32"
              })
            ]),
            _: 1
          })
        ])),
    _createVNode(TaskModal, {
      id: modalsProperties.delete.id,
      title: modalsProperties.delete.title
    }, {
      default: _withCtx(() => [
        _createVNode(BasicButton, {
          class: "btn--red",
          type: "button",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (deleteTask(_ctx.task.id)))
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Да! ")
          ]),
          _: 1
        }),
        _createVNode(BasicButton, {
          class: "btn--green",
          type: "button",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (toggleModal(modalsProperties.delete.id)))
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Нет ")
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["id", "title"]),
    _createVNode(TaskModal, {
      id: modalsProperties.closeRightsError.id,
      title: modalsProperties.closeRightsError.title
    }, {
      default: _withCtx(() => [
        _createVNode(BasicButton, {
          class: "btn--red",
          type: "button",
          onClick: toggleModalAndResetRightsError
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Понятно ")
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["id", "title"]),
    _createVNode(TaskModal, {
      id: modalsProperties.closeError.id,
      title: modalsProperties.closeError.title
    }, {
      default: _withCtx(() => [
        _createVNode(BasicButton, {
          class: "btn--red",
          type: "button",
          onClick: toggleModal
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Понятно ")
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["id", "title"])
  ], 2))
}
}

})